import uuid from 'uuid-random';
import { log } from 'log';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'js/hooks/i18n';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeofencingPopupAction } from '../actions';

export const ERROR_POPUP_ID = uuid();

export const useOnError = ({
    setShowOverlay,
    useTransparentPopup,
    geolocationType
}: {
    setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    useTransparentPopup: boolean;
    geolocationType: string;
}) => {
    const closePopups = useSmartClosePopups();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const dispatch = useDispatch();
    const t = useTranslations();

    return useCallback(async (errorCode: number, message: object) => {

        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const transactionID = geolocationData.transactionId;

        publicEventsAPIService.trigger('geofencing-error', {
            transactionID,
            errorCode,
            message
        });

        log('gcErr', {
            transactionID,
            errorCode,
            message
        });

        setShowOverlay(false);

        dispatch(showGeofencingPopupAction({
            id: ERROR_POPUP_ID,
            title: 'playtech.mobile.system.geocomply.popups.error.title',
            content: t(`playtech.mobile.system.geocomply.popups.error.${errorCode}`, String(message)),
            isModal: true,
            buttons: [
                {
                    onClick: () => closePopups(ERROR_POPUP_ID),
                    text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                    color: 'negative'
                },
                {
                    onClick: onRefresh,
                    text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                    color: 'info'
                }
            ],
            useTransparentPopup
        }));

        try {
            await validateGeolocation(null, null, JSON.stringify(message), transactionID, String(errorCode), geolocationType);
        } catch (e) {
            // noop
        }
    }, [
        t,
        onRefresh,
        closePopups,
        dispatch,
        setShowOverlay,
        useTransparentPopup,
        geolocationType
    ]);
};
